export default __webpack_public_path__ + "ffbfbd3e977da16935042abeca8675df.svg";